























































































	import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
	import associationCard from './associationCard.vue';
	import associationSearch from '@/views/sheet/components/associationSearch.vue';
	import * as sheetAPI from '@/apis/sheet';
	@Component({
		components: {
			associationCard,
			associationSearch
		}
	})
	export default class App extends Vue {
		@Prop({ default: () => ({}) }) public associationForm!: any;
		@Prop({ default: () => ({}) }) public association!: any;
    @Prop({ default: '' }) public recordId!: string;
    @Prop({ default: null }) public bidirectionalAssociation!: any;
		@Ref() private searchRef!: associationSearch;
		private tableData: any = [];
		private select: any[] = [];
		private input: string = '';
		private loading = false;
		private finished = false;
		private isHiddenCheckBtn = true;
		private visiable: boolean = false;
		// 禁止加载
		private disabled: boolean = false;
		private page = { pageNumber: 0, pageSize: 10, total: 0 };
		public async updateRecord(data) {
			let { worksheetId, businessId } = this.association;
			let res = await sheetAPI.updateRecord({ id: this.recordId, worksheetId, data });
			if (res.success) {
				this.associationForm[businessId] = data[businessId];
				await this.showAssociationList();
			}
		}
		public async showAssociationList() {
			this.select = [];
			this.input = '';
			this.visiable = true;
			this.page = { pageNumber: 0, pageSize: 10, total: 0 };
			this.finished = true;
			this.tableData = [];
			this.isHiddenCheckBtn = true;
			await this.getAssociationRecordSelect(true);
		}
		public async getAssociationRecordSelect(isStart) {
			let { businessId, worksheetId } = this.association;
			const pageNumber = this.page.pageNumber + 1;
			const data = {
				worksheetId,
				associationTableBusinessId: businessId,
				recordId: this.recordId,
				page: {
					pageNumber: pageNumber || 1,
					pageSize: 10
				}
			};
			let res = await sheetAPI.getAssociationRecordSelect(data);
			this.loading = false;
			if (res.success) {
				let { records } = res.data;
				records = records || [];
				if (isStart) {
					this.tableData = records;
				} else {
					this.tableData = this.tableData.concat(records);
				}
				this.page.total = res.data.page.total;
				this.finished = this.tableData.length >= this.page.total;
				this.page.pageNumber = pageNumber;
			}
		}
		private rowClick(id) {
			let {
				associationWorksheet: { applicationId, worksheetId },
				viewId
			} = this.association;
			this.$router.push(`/association/${applicationId}/${worksheetId}/${viewId}/${id}`);
		}
		private selectItem(id: any, index: any) {
			if (this.isHiddenCheckBtn) {
				this.rowClick(id);
				return false;
			}
			if (this.association.associationRecordCount === 1) {
				this.select = [id];
			} else if (this.select.indexOf(id) > -1) {
				this.select = this.select.filter(item => {
					return item !== id;
				});
			} else {
				this.select.push(id);
			}
		}
		private addAssociation() {
			this.searchRef.open();
		}
		private async removeFn() {
			let { businessId } = this.association;
			let recordIds = (this.associationForm[businessId] || []).filter(item => {
				return this.select.indexOf(item) === -1;
			});
			if (this.select.length === 0) {
				return
			}
      if (this.bidirectionalAssociation) {
        await sheetAPI.deleteRecordBidirectional({
          ...this.bidirectionalAssociation,
          associationTableRecordIds: this.select,
        });
        this.associationForm[businessId] = recordIds;
        this.getAssociationRecordSelect(true);
      } else {
        await this.updateRecord({ [businessId]: recordIds })
			}
			this.isHiddenCheckBtn = true
			this.select = []
      this.recordChange(recordIds);
		}
		private close() {
			this.visiable = false;
			this.$emit('close');
		}
		private async load() {
			this.getAssociationRecordSelect(false);
		}
		private async submit(selected) {
			let data = selected.map(item => {
				return item.id;
			});
			let { businessId } = this.association;
			let oldData =
				this.association.associationRecordCount === 1 ? [] : this.associationForm[businessId];
			let recordIds = [].concat(data, oldData || []);
			if (this.bidirectionalAssociation) {
        await sheetAPI.relevanceRecord({
					...this.bidirectionalAssociation,
					associationTableRecordIds: data
				});
				this.associationForm[businessId] = recordIds;
				this.getAssociationRecordSelect(true);
			} else {
				this.updateRecord({ [businessId]: recordIds }).then(() => {
					this.recordChange(recordIds);
				});
			}
    }
		private recordChange(recordIds) {
			this.$emit('recordChange', recordIds, this.tableData[0]);
		}
	}
